module.exports = __webpack_public_path__ + "static/media/mc_tube.ddb1c75a.svg";